// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"jP-z","carouselContainer":"kP-z"};